import {
  Component,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { Filter, FilterData, FILTERS } from '../filter';

@Component({
  selector: 'atm-filter-editor',
  templateUrl: './filter-editor.component.html',
  styleUrls: ['./filter-editor.component.scss'],
})
export class FilterEditorComponent {
  @HostListener('document:keydown', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    if (event.ctrlKey && event.key === 'Enter') {
      this.dialogRef.close(this.filtersSetted);
    }
  }
  private readonly destroyed = new Subject<void>();

  newFilter: FilterData | null = null;
  changedFilter: number | null = null;
  newFilterSetted = false;

  current = false;
  options: Record<string, boolean> = {};

  filtersSetted: FilterData<Filter>[];

  constructor(
    private dialogRef: MatDialogRef<FilterEditorComponent, FilterData[]>,
    @Inject(FILTERS) public readonly filters: Filter[] = [],
    @Inject(MAT_DIALOG_DATA)
    public data: {
      data: FilterData[];
      filters: Filter[];
      currentFilter: {
        available: boolean;
        setted: boolean;
        filter?: Filter;
      };
      preset: FilterData;
    }
  ) {
    this.filtersSetted = data.data;
    if (data.preset) {
      this.newFilter = data.preset;
      this.changedFilter = data.data.findIndex(
        (filter) =>
          filter.operation === data.preset.operation &&
          filter.value === data.preset.value
      );
    }
    if (data.currentFilter.available) {
      this.current = data.currentFilter.setted;
      this.options['current'] = true;
    }
  }

  setCurrentFilter() {
    if (this.current) {
      this.filtersSetted.push({
        filter: this.data.currentFilter.filter as Filter,
        operation: this.data.currentFilter.filter!.defaultOperation,
        value: 'now',
      });
    } else {
      this.filtersSetted = this.filtersSetted.filter(
        (f) => f.filter.type !== 'current'
      );
    }
  }

  changeFilter(filter: FilterData, index: number) {
    this.newFilter = filter;
    this.changedFilter = index;
  }

  selectFilter(filter: Filter) {
    if (this.newFilter?.filter === filter) {
      this.newFilter = null;
    } else {
      this.newFilter = {
        filter,
        operation: filter.defaultOperation,
        value: '',
      };
    }
  }
  setFilter($event: FilterData): void {
    this.newFilter = { ...$event };
  }

  addFilter(): void {
    if (this.newFilter?.value && this.newFilter?.value?.toString().length) {
      if (this.changedFilter !== null) {
        this.filtersSetted[this.changedFilter] = { ...this.newFilter };
        this.changedFilter = null;
      } else {
        this.filtersSetted.push({ ...this.newFilter! });
      }
      this.newFilter = {
        filter: this.newFilter.filter,
        operation: this.newFilter.filter.defaultOperation,
        value: '',
      };
      this.newFilterSetted = true;
    }
  }

  removeFilter(index: number): void {
    this.filtersSetted = this.filtersSetted.filter((_, i) => i !== index);
    this.newFilterSetted = true;
  }

  submit(): void {
    this.dialogRef.close(this.filtersSetted!);
  }
}
